const values = {
    "APP_NAME": "Topup Agencias",
}

export default values;